import { F as FronteggApp, a as ReactDom } from './FronteggApp-069cf29e.js';
import { createElement } from './utils.js';
import { AppHolder } from './AppHolder.js';
export { AdminPortal } from './AdminPortal.js';
export { HostedLogin } from './HostedLogin.js';
export { LoginBoxRenderer, defaultTheme, getThemeByName } from './LoginBoxRenderer.js';
export * from '@frontegg/redux-store';
import '@frontegg/types';
import '@frontegg/rest-api';
import './index-60bf5390.js';
import './Link-978e3220.js';

const initialize = (options, name = 'default') => {
    var _a;
    const createdApp = new FronteggApp(options, name);
    if (typeof document !== 'undefined') {
        if (!customElements.get('frontegg-app')) {
            class FronteggAppContainer extends HTMLElement {
                constructor() {
                    super(...arguments);
                    this.app = null;
                }
                static get observedAttributes() {
                    return ['app-name'];
                }
                connectedCallback() {
                    this.updateContent();
                }
                attributeChangedCallback(name, oldValue, newValue) {
                    if (name === 'app-name') {
                        if (oldValue === null) {
                            return;
                        }
                        const app = AppHolder.getInstance(oldValue);
                        try {
                            ReactDom.unmountComponentAtNode(app.adminPortalEl);
                            ReactDom.unmountComponentAtNode(app.loginBoxEl);
                        }
                        catch (e) {
                            console.error('Failed to unmount frontegg app', e);
                        }
                        this.innerHTML = '';
                        if (newValue === null) {
                            this.remove();
                        }
                        else {
                            this.updateContent();
                        }
                    }
                    console.log('attributeChangedCallback', name, oldValue, newValue);
                }
                updateContent() {
                    var _a;
                    const appName = (_a = this.getAttribute('app-name')) !== null && _a !== void 0 ? _a : 'default';
                    const app = AppHolder.getInstance(appName);
                    if (app === null) {
                        throw Error(`FronteggApp not found for appName: '${appName}'`);
                    }
                    this.setAttribute('id', `frontegg-app-${app.name}`);
                    const adminPortalContainer = createElement(this, 'div', { id: `frontegg-admin-portal-container-${app.name}` });
                    const loginBoxContainer = createElement(this, 'div', { id: `frontegg-login-box-container-${app.name}` });
                    const adminBoxShadowEl = adminPortalContainer.attachShadow({ mode: 'open' });
                    const loginBoxShadowEl = loginBoxContainer.attachShadow({ mode: 'open' });
                    const adminPortalEl = createElement(adminBoxShadowEl, 'div', {
                        id: `frontegg-admin-portal-${app.name}`,
                        class: 'frontegg-root-content',
                    });
                    const loginBoxEl = createElement(loginBoxShadowEl, 'div', {
                        id: `frontegg-login-box-${app.name}`,
                        class: 'frontegg-root-content',
                    });
                    app.initContainers({ adminPortalEl, loginBoxEl, adminPortalContainer, loginBoxContainer });
                }
            }
            customElements.define('frontegg-app', FronteggAppContainer);
        }
        (_a = document.querySelector(`frontegg-app[app-name="${createdApp.name}"]`)) === null || _a === void 0 ? void 0 : _a.remove();
        const element = document.createElement('frontegg-app');
        element.setAttribute('app-name', createdApp.name);
        document.body.appendChild(element);
    }
    return createdApp;
};

export { initialize };
